module.exports = __webpack_public_path__ + "static/img/office_02.5f35645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/office_02.png
// module id = g4H5
// module chunks = 0